import { z } from 'zod';
import { flag, str } from '../../navigation/searchParams';

/**
 * `error`/`detail` come back from a failed SwiftGate callback, `logged_out`
 * and `reset_success` from signing out and resetting a password, and
 * `redirect` is where a signed-out visitor was going (checked by
 * `safeRedirect` before it is followed).
 */
export const loginSearch = z.object({
  error: str,
  detail: str,
  logged_out: flag,
  reset_success: str,
  redirect: str,
});
